export default __webpack_public_path__ + "static/media/bedroom.35eaf91a.jpg";